import Icon from '@material-ui/icons/Done';
import { StatusCheckerList } from './StatusCheckerList';

export default {
  icon: Icon,
  list: StatusCheckerList,
};
